import { useNavigate } from "react-router-dom";
import { posterUrl, backdropUrl } from "../api/images";
import { yearOf } from "../lib/format";

export default function PosterCard({ card, progress, wide = false }) {
  const navigate = useNavigate();
  // Wide cards (TV rails) keep the 16:9 backdrop, like the TV app's show rows.
  const url = wide
    ? backdropUrl(card.backdropPath, { hero: false }) || posterUrl(card.posterPath)
    : posterUrl(card.posterPath, { large: false });
  const year = yearOf(card.date);
  const typeLabel = card.contentType === "TV_SHOW" ? "TV Show" : "Movie";
  const fraction = progress ? (progress.completed ? 1 : Math.min(1, progress.positionSeconds / (progress.durationSeconds || 1))) : 0;

  const detailRoute =
    card.contentType === "TV_SHOW" ? `/show/${card.tmdbId}` : `/movie/${card.tmdbId}`;
  // Manual-library episode cards go straight to the player (there is no TMDB
  // detail page for a title TMDB has never catalogued) and label the card with
  // the episode plus the show's language instead of year + type.
  const route = card.playUrl || detailRoute;
  const aria = card.episodeLabel
    ? `${card.title} ${card.episodeLabel}`
    : `${card.title}${year ? ` (${year})` : ""}`;

  return (
    <button
      className={`poster-card${wide ? " wide" : ""}`}
      onClick={() => navigate(route)}
      aria-label={aria}
    >
      <div className="poster-frame">
        {url ? (
          <img className="poster-img" src={url} alt="" loading="lazy" />
        ) : (
          <div className="poster-fallback">
            <span>{card.title}</span>
          </div>
        )}
        <div className="poster-hover">
          <span className="poster-play" aria-hidden="true">▶</span>
        </div>
        {fraction > 0 && (
          <div className="poster-progress">
            <div className="poster-progress-fill" style={{ width: `${fraction * 100}%` }} />
          </div>
        )}
      </div>
      <span className="poster-card-info">
        <span className="poster-card-title">{card.title}</span>
        <span className={`poster-card-meta${card.episodeLabel ? " episode" : ""}`}>
          {card.episodeLabel ? (
            <span className={`poster-card-episode${card.live ? " live" : ""}`}>{card.episodeLabel}</span>
          ) : (
            year && <span className="poster-card-year">{year}</span>
          )}
          {card.language ? (
            <span className="poster-card-lang">{card.language}</span>
          ) : (
            <span className="poster-card-type">{typeLabel}</span>
          )}
        </span>
      </span>
    </button>
  );
}
